import React, { useRef, useEffect } from 'react';
import { useMediaQuery } from '../helpers/useMediaQuery';
import bg from '../images/globe/bg-2.png';
import clouds from '../images/globe/clouds.png';
function Globe() {
	const globeRef = useRef(null);
	const isPageWide = useMediaQuery('(min-width: 1200px)');

	useEffect(async () => {
		if (!isPageWide) return;
		const { GlobeKitView, PointGlobe, Background, Atmosphere } =
			await import('globekit-public');

		async function fetchMyAPI() {
			const gkview = new GlobeKitView(globeRef.current, {
				apiKey: 'gk_fbb5b82000622ec2c4746c659bc539983d5789c38e0d7af617379e6b40dac27c308c27a2ec09fcb087ed5b968e0b3727b44f28b13dfbe2c550649de4025d0161',
				wasmPath:
					'https://fuselogo.s3.eu-central-1.amazonaws.com/gkweb_bg.wasm',
				attributes: {},
			});

			const background = new Background(bg);
			gkview.addDrawable(background);
			const data = await fetch(
				'https://fuselogo.s3.eu-central-1.amazonaws.com/pointglobe.bin',
			).then((res) => res.arrayBuffer());
			const pointglobeParams = {
				pointSize: 0.004,
				randomPointSizeVariance: 0.004,
				randomPointSizeRatio: 0.1,
				minPointAlpha: 0.0,
				minPointSize: 0.006,
				color: '#fff',
			};
			const pointglobe = new PointGlobe(
				{ noise: clouds },
				data,
				pointglobeParams,
			);
			pointglobe.setInteractive(true, true, false);
			gkview.addDrawable(pointglobe, () => {
				gkview.startDrawing();
			});
		}
		if (globeRef.current) {
			fetchMyAPI();
		}
	}, [globeRef, isPageWide]);

	if (!isPageWide) return null;
	return <canvas ref={globeRef} className="globe" />;
}

export default Globe;
